import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import Sidebar from './SideBar';
import OfferingModal from './OfferingModal';

const Location = () => {


    // State Variables
    const [searchQuery, setSearchQuery] = useState('');
    const [employees, setEmployees] = useState([
        {
            employeeName: 'John Doe',
            employeeId: 'EMP-001',
        },
        {
            employeeName: 'Jane Smith',
            employeeId: 'EMP-002',
        },
    ]);
    const [filteredEmployees, setFilteredEmployees] = useState(employees);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [isModalOpen, setIsModalOpen] = useState(false);

    // Effect to handle filtering
    useEffect(() => {
        const filtered = employees.filter((employee) =>
            Object.values(employee).some((value) =>
                String(value).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
        setFilteredEmployees(filtered);
        setCurrentPage(1); // Reset to first page on new search
    }, [searchQuery, employees]);

    // Pagination Logic
    const totalPages = Math.ceil(filteredEmployees.length / itemsPerPage);
    const currentData = filteredEmployees.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // Handlers
    const handleSearch = (e) => setSearchQuery(e.target.value);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    return (
        <>
            <div className="oms-header">
                <h1 className="dashboard-title">Employee Trace</h1>
            </div>

            {/* Search Filter */}
            <div className="filter-search">
                <div className="filter-search-input">
                    <input
                        type="search"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                    />
                    <i className="fa fa-search"></i> {/* Font Awesome Search Icon */}
                </div>
            </div>

            {/* Employee Table */}
            <div className="customer-table">
                <table>
                    <thead>
                        <tr>
                            <th>Employee Name</th>
                            <th>Employee ID</th>
                            <th>Trace Location</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentData.length > 0 ? (
                            currentData.map((employee, index) => (
                                <tr key={index}>
                                    <td>{employee.employeeName}</td>
                                    <td>{employee.employeeId}</td>
                                    <td>
                                        <button className="trace-button">
                                            Trace
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="3" style={{ textAlign: 'center' }}>No data found.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Pagination */}
            <div className="pagination">
                <button
                    onClick={() => paginate(currentPage - 1)}
                    disabled={currentPage === 1}
                >
                    Previous
                </button>
                {Array.from({ length: totalPages }, (_, index) => (
                    <button
                        key={index}
                        onClick={() => paginate(index + 1)}
                        className={currentPage === index + 1 ? 'active' : ''}
                    >
                        {index + 1}
                    </button>
                ))}
                <button
                    onClick={() => paginate(currentPage + 1)}
                    disabled={currentPage === totalPages}
                >
                    Next
                </button>
            </div>
            {/* <OfferingModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} /> */}
        </>
    );
};

export default Location;
